import { useInfiniteQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import loadBoardChangeLogService from "app/data/load-board/loadBoardChangeLogService";
import { LoadBoardChangeLogFilterParams } from "app/data/load-board/loadBoardChangeLogModels";

export const useLoadBoardChangeLog = (
  filter: LoadBoardChangeLogFilterParams = {},
  enabled = true
) => {
  const { dateFrom, dateTo, actionType, search, manifestNumber, terminalNumber } = filter;

  return useInfiniteQuery({
    queryKey: [
      QUERY_KEYS.LOAD_BOARD_CHANGE_LOG,
      "search",
      actionType,
      search,
      manifestNumber,
      terminalNumber,
      dateFrom,
      dateTo,
    ],
    queryFn: async ({ pageParam = 0 }) => {
      return loadBoardChangeLogService.search(
        {
          dateFrom,
          dateTo,
          actionType,
          search,
          manifestNumber,
          terminalNumber,
        },
        pageParam
      );
    },
    getNextPageParam: (lastPage) => {
      if (lastPage?.last) return undefined;
      return (lastPage?.pageable?.pageNumber ?? 0) + 1;
    },
    enabled,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
